<template>
    <el-table
        id="preOrderTable"
        style="width: 100%"
        max-height="500"
        :data="preOrders"
        @row-click="$router.push(`/preorder/${$event.id}`)"
    >
        <el-table-column
            v-for="column in tableColumns"
            :key="column.label"
            :width="column.width"
            :min-width="column.minWidth"
            :prop="column.prop"
            :label="column.label"
            :sortable="column.sortable"
            :formatter="column.formatter"
            :sort-method="column.sortMethod"
            :show-overflow-tooltip="true"
        />
    </el-table>
</template>

<script>
import moment from "moment-timezone";

export default {
    name: "InvoicesTable",
    props: {
        preOrders: {
            type: Array,
            required: true,
        },
        excludeColumns: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        tableColumns() {
            let columns = [
                {
                    prop: "id",
                    label: "Pre-Order No.",
                    sortable: true,
                },
                {
                    prop: "CustomerJobID",
                    label: "Job/Project Name",
                    sortable: true,
                },
                {
                    prop: "customer.name",
                    label: "Customer",
                    sortable: true,
                },
                {
                    prop: "designer.fullName",
                    label: "Designer",
                    width: 125,
                    sortable: true,
                },
                {
                    prop: "expectedAt",
                    label: "Expected By",
                    sortable: true,
                    sortMethod: (a, b) => new Date(b.date) - new Date(a.date),
                    formatter: (row) => this.formatDate(row.expectedAt),
                },
                {
                    prop: "unitCount",
                    label: "# of Units",
                    sortable: true,
                },
                {
                    prop: "updatedAt",
                    label: "Last Updated",
                    sortable: true,
                    sortMethod: (a, b) =>
                        new Date(b.dueDate) - new Date(a.dueDate),
                    formatter: (row) => this.formatDate(row.updatedAt),
                },
            ];
            // eslint-disable-next-line max-len
            columns = columns.filter(
                (column) =>
                    this.excludeColumns.findIndex(
                        (hide) => hide === column.label,
                    ) === -1,
            );
            return columns;
        },
    },
    methods: {
        formatDate(date) {
            if (date) {
                return moment(date).format("MM/DD/YYYY");
            }
            return "--";
        },
    },
};
</script>
